export default __webpack_public_path__ + "images/KS.5f28fb8.png";